import { apiClient } from '../lib/api/api-client';

export interface EventInfo {
  id: string;
  name: string;
  shortDescription: string;
  richDescription: string;
  startTime: string;
  endTime: string;
  location: string;
  maxSeatByUser: number;
  organizerUserIds: string[];
  createdAt: string;
  updatedAt: string;
}

export interface EventsListResponse {
  status: {
    code: string;
    message: string;
  };
  metaData: {
    timestamp: number;
  };
  data: EventInfo[];
}

export class EventsService {
  /**
   * Fetch all events the current user is organizing or has access to
   */
  static async getAllEvents(): Promise<EventInfo[]> {
    try {
      const response = await apiClient.get<EventInfo[]>(
        '/admin-portal/api/admin/events'
      );
      console.log('API Response:', response.data); // Log the API response
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch events list:', error);
      throw new Error(`Failed to fetch events list: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }
}

export default EventsService;
